module.exports = __webpack_public_path__ + "static/media/ILEL.ecc4ea2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/ILEL.jpg
// module id = 1757
// module chunks = 1